query GetContactFormValidation($input: ContactCreateValidationInput!) {
    contactCreateValidation(input: $input) {
        errors {
            field
            error
        }
    }
}
